import { Guid } from "@/types"

export interface IGetGlobalAssetOverviewTenantDto {
    id: Guid
    tenantName: string
    contactInformation: string
}

export default class GlobalAssetOverviewTenant {
    id: Guid
    tenantName: string
    contactInformation: string

    constructor(dto: IGetGlobalAssetOverviewTenantDto) {
        this.id = dto.id
        this.tenantName = dto.tenantName
        this.contactInformation = dto.contactInformation
    }
}
